import apiService from '../apiService';

const CONTACT_URL = 'contacts'
const contactService = {

    async createContactType(payload) {
        try {
            const response = await apiService.post(`/${CONTACT_URL}/types`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllContactsType(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await apiService.get(`/${CONTACT_URL}/types${queryParams ? `?${queryParams}` : ''}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleContactType(id) {
        try {
            const response = await apiService.get(`/${CONTACT_URL}/types/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateContactType(payload, id) {
        try {
            const response = await apiService.put(`/${CONTACT_URL}/types/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteContactType(id) {
        try {
            const response = await apiService.delete(`/${CONTACT_URL}/types/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default contactService;